import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  teamDetailsWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginTop: "56px",
    maxWidth: "352px",
    "& h1": {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
      color: colors.lightBlack,
      marginBottom: "8px"
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: colors.mediumGrey,
      marginBottom: "32px"
    }
  },
  invBtn: {
    fontSize: "16px",
    height: "40px"
  },
  logo: {
    marginBottom: "20px"
  }
}));

export default styles;
